import { Fragment, h } from 'preact'; /** @jsx h */
import { useEffect, useRef } from 'preact/compat';

import './InlineCTA.scss';

const InlineCTA = ({
    buttonText = 'Bli støttemedlem',
    link = '/stottemedlem/',
    color = 'secondary',
    children,
    type = '',
    imgSrc = '',
    alt = ''
}) => {
    const inlineCTARef = useRef();

    const buttonTextParts = buttonText.split(' - ');
    const isMobile = window.innerWidth < 768;

    useEffect(() => {
        if (window.innerWidth < 1024) {
            // eslint-disable-next-line no-undef
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.boundingClientRect.top < 16) {
                        inlineCTARef.current.classList.add('sticky');
                    } else {
                        inlineCTARef.current.classList.remove('sticky');
                    }
                },
                { threshold: 1, rootMargin: '-8px 0px 0px 0px' }
            );

            if (inlineCTARef.current) {
                observer.observe(inlineCTARef.current);
            }

            return () => {
                if (inlineCTARef.current) {
                    observer.unobserve(inlineCTARef.current);
                }
            };
        }
    }, []);
    return (
        <Fragment>
            {type === 'text' && children && (
                <div className="inner-text">
                    <a className="inner-text-link" href={link}>
                        {children}
                    </a>
                </div>
            )}
            {type === 'image' && imgSrc && (
                <div className="inner-image">
                    <a className="inner-image-img" href={link}>
                        <img src={imgSrc} alt={alt} />
                    </a>
                </div>
            )}

            <div
                ref={inlineCTARef}
                className={`btn-container color-${color} ${type === 'text' && 'with-text'} ${
                    type === 'image' && 'with-image'
                }`}
            >
                <a className="link-btn" href={link}>
                    <span>
                        {isMobile && buttonTextParts.length > 1 ? (
                            <span className="link-mobile-text">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: buttonTextParts[0]
                                    }}
                                />
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: buttonTextParts[1]
                                    }}
                                />
                            </span>
                        ) : (
                            <span
                                className="link-text"
                                dangerouslySetInnerHTML={{
                                    __html: buttonText
                                }}
                            />
                        )}
                    </span>
                    <span className="material-symbols-outlined">arrow_forward</span>
                </a>
            </div>
        </Fragment>
    );
};

export default InlineCTA;
